import { getAllSpecializationAreasReq } from "../../../../redux/guest-slices/common.slice"
import SpecializationAreas from "../../../../components/ui/SpecializationAreas"
import InputField1 from "../../../../components/ui/InputField1"
import FileInput from "../../../../components/ui/FileInput"
import { Grid2 as Grid, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { Fragment, useEffect, useState } from "react"
import { validateNumber } from "../../../../utils/velidations"

function MindfulnessCoach({ errors, files, onChangFun }) {
  const dispatch = useDispatch()
  const [areas, setAreas] = useState([])
  const { specialist } = useSelector(state => state.specialistSlice)

  const handleGetAreas = (filters) => {
    dispatch(getAllSpecializationAreasReq({
      limit: filters?.limit || 10,
      id: "67d90056c2c4d5ab747f8b40"
    })
    ).unwrap().then((data) => {
      setAreas(data)
    }).catch(() => { })
  }

  useEffect(() => {
    handleGetAreas()

    // eslint-disable-next-line
  }, [])

  return (
    <Fragment>
      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="specializationCertificate"
          label="Training in Mindfulness or Resilience Building Techniques *"
          defaultValue={specialist?.profile?.specializationCertificate || []}
          errText="Please upload training in mindfulness or resilience building techniques"
          placeholderText="Upload Training in Mindfulness or Resilience Building Techniques"
        />
      </Grid>

      <Grid size={12}>
        <SpecializationAreas
          areas={areas}
          errors={errors}
          onChangFun={onChangFun}
          label="Specific Techniques or Programs Offered *"
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="text"
          errors={errors}
          name="experience"
          onChangeFun={validateNumber}
          label="Professional Experience *"
          placeholder="Enter Professional Experience"
          errText="Please enter professional experience"
        />
      </Grid>

      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="additionalCertificates"
          label="Section for Credentials"
          placeholderText="Upload Additional Certificates"
          defaultValue={specialist?.profile?.additionalCertificates || []}
        />
      </Grid>

      <Typography
        color="#7A8A9E"
        fontWeight="500"
        fontStyle="italic"
      >Welcome Mindfulness and Resilience Trainers. Your role in teaching techniques to build resilience and mindfulness is key to our members' well-being. Please enter your training background and methodologies
      </Typography>
    </Fragment>
  )
}

export default MindfulnessCoach